import jwt_decode from "jwt-decode";
import {geturl} from "../components/Login";

export function isValidLogin(role) {
    let cosToken = localStorage.getItem('cosToken')
    if (cosToken == null) {
        return false
    }
    let decodedToken=jwt_decode(cosToken);

    let dateNow = new Date();
    if(decodedToken.exp < (dateNow.getTime() /1000)) {
        return false
    }
    switch(decodedToken.optinestUser.optinestApiUser.role) {
        case role:
            return true
            break;
        case 'AGENT':
            localStorage.removeItem('cosToken');
            window.location.href=geturl('manage')
            break;
        case 'ADMIN':
            localStorage.removeItem('cosToken');
            window.location.href=geturl('backoffice')
            break;
        case 'WORKER':
            localStorage.removeItem('cosToken');
            window.location.href=geturl('workers')
            break;
        default:
            localStorage.removeItem('cosToken');
            return false;
    }
}

export function getCurrentUserInfo() {
    let cosToken = localStorage.getItem('cosToken')
    if (cosToken == null) {
        return {}
    }
    let decodedToken=jwt_decode(cosToken);

    return decodedToken?.optinestUser?.optinestApiUser
}

export function getheaders() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let cosToken = localStorage.getItem('cosToken')
    if (!isValidLogin('WORKER')) {
        window.location.href = "/login";
    }
    myHeaders.append("Authorization", cosToken)
    return myHeaders;
}